import { render, staticRenderFns } from "./forgot-your-password.vue?vue&type=template&id=45dfacbb&scoped=true&lang=pug&"
import script from "./forgot-your-password.vue?vue&type=script&lang=js&"
export * from "./forgot-your-password.vue?vue&type=script&lang=js&"
import style0 from "./forgot-your-password.vue?vue&type=style&index=0&lang=stylus&"
import style1 from "./forgot-your-password.vue?vue&type=style&index=1&id=45dfacbb&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45dfacbb",
  null
  
)

export default component.exports